const teamData = [
  {
    name: 'Haneesh Bandaru',
    Image: '',
    rollNumber: '20VV1A1220',
    year: '2023-2024',
    website:'',
    linkedin: 'https://www.linkedin.com/in/haneesh-bandaru/',
    github: 'https://github.com/haneesh-bandaru',
    instagram: 'https://www.instagram.com/haneesh_bandaru/',
    email: 'mailto:haneeshbandaru@gmail.com',
  },
  {
    name: 'Thiruvayapeta Srimanth Kumar', 
    Image: '',
    rollNumber: '20VV1A1259',
    year: '2023-2024',
    website:'',
    linkedin: 'https://www.linkedin.com/in/srimanth-thiruvayapeta-226074243/',
    github: 'https://github.com/srimanth-kumar',
    instagram: 'https://www.instagram.com/srimanth_kumar/',
    email: 'mailto:srimanthkumar@gmail.com',
  },
  {
    name: 'Dannana Sai Ajith Kumar',
    Image: '',
    rollNumber: '21VV5A1268',
    year: '2023-2024',
    linkedin: 'https://www.linkedin.com/in/saiajithkumardannana/',
    github: 'https://github.com/dannana-sai-ajith-kumar',
    website: 'https://dsak.in/',
    instagram: 'https://www.instagram.com/dannana_sai_ajith_kumar/',
    email: 'mailto:dsak.official@gmail.com',
  },
  {
    name: 'Anil Sinthu',
    Image: '',
    rollNumber: '22VV5A1273',
    year: '2024-Tilldate',
    role: 'Full Stack Developer',
    website:'https://anilsinthu.vercel.app/',
    linkedin: 'https://www.linkedin.com/in/anilsinthu',
    github: 'https://github.com/anilsinthu73',
    instagram: 'https://www.instagram.com/mr.anil_sinthu/',
    email: 'mailto:anilsinthu114@gmail.com',
  },
  {
    name: 'Harsha Vivek Gangadhar',
    Image: '',
    rollNumber: '21VV1A1203',
    year: '2024-Tilldate',
    role: 'Frontend Developer',
    linkedin: 'https://www.linkedin.com/in/harsha-vivek-a47309243/',
    website: 'https://harsha-vivek03.github.io/personalportfolio/',
    github: 'https://github.com/harsha-vivek03',
    instagram: 'https://www.instagram.com/the_hidden_hate/',
    email: 'mailto:hvgnani79813@gmail.com',
  },
  {
    name: "Tarun Bommali",
    Image: "",
    rollNumber: '',
    year : "2025 - Till date",
    linkedin: '',
    website: '',
    github: 'https://github.com/tarunbommali',
    instagram: '',
    email : ''
  }
];

export default teamData;

